import { useEffect } from 'react';

import { BUTTON_SIZES, PrimaryButton } from 'ui/button';

import { SUBMIT_REVIEW_STEP } from './constants';
import { useImportMutation } from './hooks/useImportMutation';
import { FormFieldKey, FormState } from './types';

type StartImportButtonProps = Pick<
  FormState,
  FormFieldKey.IdType | FormFieldKey.ImportType | FormFieldKey.ChangeComment
> & {
  isDisabled: boolean;
  onSuccessfulImport: () => void;
};

export const StartImportButton = ({
  idType,
  importType,
  changeComment,
  isDisabled,
  onSuccessfulImport,
}: StartImportButtonProps) => {
  const { didImport, importIds, isLoading } = useImportMutation(idType, importType, changeComment);

  useEffect(() => {
    if (!isLoading && didImport) onSuccessfulImport();
  }, [isLoading, didImport]);

  return (
    <PrimaryButton
      size={BUTTON_SIZES.LARGE}
      isDisabled={isDisabled || isLoading}
      onClick={importIds}
      isLoading={isLoading}
    >
      {SUBMIT_REVIEW_STEP}
    </PrimaryButton>
  );
};
